import React from 'react';
import {useEffect, useState} from 'react';
import * as Panel2 from './panel';
import * as LLReact from './cg/cgreact';
import {PanelComp2} from './PanelComp';
import {Spec as PanelTable2Spec} from './PanelTable2';
import {Spec as PanelFacetSpec} from './PanelFacet';
import * as CGTable from './tableState';

const inputType = {
  type: 'dict' as const,
  objectType: {
    type: 'table-info' as const,
  },
};

export type PanelTableConfig = CGTable.TableState;

type PanelTableProps = Panel2.PanelProps<typeof inputType, PanelTableConfig>;

const PanelTable: React.FC<PanelTableProps> = props => {
  const {config, context, updateConfig, updateContext} = props;

  // const [visType, setVisType] = useState<'table' | 'facet'>('table');
  const [visType] = useState<'table' | 'facet'>('table');

  const initTable = LLReact.useContextBound(
    CGTable.initTableWithAllColumnsFromTableType
  );
  const tableRowsNode = props.input.path;
  // TODO: This is not what we want! This must make a query for the
  // table type whenever this panel is loaded, but we don't actually
  // need the type to render something that's already configured
  useEffect(() => {
    async function getTableRows() {
      const initialTableState = await initTable(tableRowsNode);
      updateConfig(initialTableState);
    }
    getTableRows();
    // putting updateConfig here would cause a loop
    // TODO: FIX ME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initTable, tableRowsNode]);

  if (tableRowsNode == null || config.columns == null) {
    return <div></div>;
  }
  return (
    <div>
      {/* <div>
        <span
          style={{
            cursor: 'pointer',
            borderBottom: visType === 'table' ? '1px solid #888' : undefined,
          }}
          onClick={() => setVisType('table')}>
          table
        </span>
        {' | '}
        <span
          style={{
            cursor: 'pointer',
            borderBottom: visType === 'facet' ? '1px solid #888' : undefined,
          }}
          onClick={() => setVisType('facet')}>
          facet
        </span>
      </div> */}
      {visType === 'facet' ? (
        <PanelComp2
          input={{path: tableRowsNode as any}}
          inputType={tableRowsNode.type}
          loading={false}
          panelSpec={PanelFacetSpec}
          configMode={false}
          context={context}
          config={config}
          updateConfig={updateConfig}
          updateContext={updateContext}
        />
      ) : (
        <PanelComp2
          input={{path: tableRowsNode as any}}
          inputType={tableRowsNode.type}
          loading={false}
          panelSpec={PanelTable2Spec}
          configMode={false}
          context={context}
          config={config}
          updateConfig={updateConfig}
          updateContext={updateContext}
        />
      )}
    </div>
  );
};

export const Spec: Panel2.PanelSpec = {
  id: 'table',
  Component: PanelTable,
  inputType,
};
